/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { store } from 'redux/store';
import { useNavigate, useLocation } from 'react-router-dom';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

import WizardSteps from '../wizard-steps';
import SearchTabList from '../search-tab-list';

const AddNewPSVEquipment = ({
  asset = false,
  setActive,
  setAddNew,
  setSelectedPSVEvent,
  alreadyAttachedPSV = [],
  siteId = null
}) => {
  const navigate = useNavigate();

  const [step, setStep] = useState(0);
  const assetKind = 'Equipment';

  const steps = [
    {
      title: `Selection is limited to your cached data.`,
      content: (
        <SearchTabList
          label={assetKind}
          psvEquipments
          siteId={siteId}
          alreadyAttachedPSV={alreadyAttachedPSV}
          onSelect={(id) => {
            setSelectedPSVEvent({ id });
            // setAddNew('');
            // setActive(false);
            // setTimeout(() => {
            //   navigate(`/add-edit-equipment?new-equipmentId=${uuidv4()}&siteId=${id}`);
            // }, 0);
          }}
        />
      )
    },
    {
      title: 'New Check Added Successfully.',
      content: ''
    }
  ];

  const onClickStep = (step) => {
    setStep(step);
  };

  return (
    <div>
      <WizardSteps
        current={1}
        setStep={onClickStep}
        total={1}
        title={steps[step].title}
        content={steps[step].content}
        breadcrumbs={[assetKind]}
        notShowSteps={false}
        psvEquipments
      />
    </div>
  );
};

export default AddNewPSVEquipment;
